package com.patronat.top.client.data.profile

import com.patronat.top.core.domain.models.DomainResult
import com.patronat.top.core.network.asDomainResult
import com.patronat.top.dto.ContactSupportRequest
import com.patronat.top.dto.ContactSupportResponse
import com.patronat.top.dto.DeleteCurrentUserRequest
import com.patronat.top.dto.ProfileSuccessResponse
import com.patronat.top.dto.UpdateCurrentUserRequest

class ClientProfileRepository(
    private val remoteDataSource: ClientProfileRemoteDataSource
) {
    suspend fun getCurrentUser(): DomainResult<ProfileSuccessResponse> {
        return remoteDataSource.getCurrentUser().asDomainResult { it }
    }

    suspend fun updateCurrentUser(request: UpdateCurrentUserRequest): DomainResult<ProfileSuccessResponse> {
        return remoteDataSource.updateCurrentUser(request).asDomainResult { it }
    }

    suspend fun submitContactMessage(request: ContactSupportRequest): DomainResult<ContactSupportResponse> {
        return remoteDataSource.submitContactMessage(request).asDomainResult { it }
    }

    suspend fun deleteCurrentUser(request: DeleteCurrentUserRequest): DomainResult<Unit> {
        return remoteDataSource.deleteCurrentUser(request).asDomainResult { it }
    }
}
